import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  autoOpen: booleanAttribute(),
  locationUrl: { type: String, default: undefined },
  /**
   * Seeds the location step's distance filter so the search opens at the
   * client-configured default radius (filter_options.distance.default) once a
   * location is chosen, instead of "Any Distance". A distance already present
   * in the URL / persisted location wins: it skips the location step and seeds
   * locationData directly, so this default only applies to a fresh selection.
   *
   * @type {Number|String}
   */
  defaultDistance: { type: [Number, String], default: undefined },
  /**
   * The distance options (in miles) for the location step's distance select
   * (filter_options.distance.values), as a JSON array string attribute. When
   * omitted, the nested DistanceFilter falls back to its built-in list.
   *
   * @type {Array|String}
   */
  distances: { type: [Array, String], default: undefined },
  /**
   * Which control picks the distance ("select" | "slider"), from
   * filter_options.distance.control. The slider snaps through `distances`.
   * Omitted → the select.
   *
   * @type {String}
   */
  distanceControl: { type: String, default: undefined },
  /**
   * Offers an "Any Distance" option in the location step's distance select
   * (filter_options.distance.allow_any). Absent, a required location always
   * carries a concrete radius.
   *
   * @type {Boolean|String}
   */
  allowAnyDistance: booleanAttribute(),
  /**
   * Placeholder for the location step's search input. When omitted, the nested
   * DistanceFilter falls back to its own default ("City, address, or zip code").
   *
   * @type {String}
   */
  searchPlaceholder: { type: String, default: undefined },
  /**
   * Standalone mode (detail pages) has no finder to read the persist settings
   * from, so the client passes them in (filter_options.persist_location /
   * persist_insurance_plan).
   *
   * @type {Boolean|String}
   */
  persistLocation: booleanAttribute(),
  persistInsurancePlan: booleanAttribute(),
});
